import { Stack, StackProps } from "@mui/material";

type PageHeaderContainerProps = StackProps & {};
export const PageHeaderContainer = (props: PageHeaderContainerProps) => {
  return <Stack {...props}>{props.children}</Stack>;
};
